module.exports = __webpack_public_path__ + "img/digital.94b44203.svg";